import React from "react";
import "./GoogleRatingCard.css";

const GoogleRatingCard = () => {
  return (
    <div className="google-rating-wrapper-pre">
      <img
        src="/assets/img/Group385.png"
        alt="Rating Stars"
      />
    </div>
  );
};

export default GoogleRatingCard;
